<!-- 投放分组 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">投放分组</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 小组名称 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.group_name}}
			</div>
			<!-- 分组类型，0=系统分组，1=投放分组 -->
			<!-- <div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.group_type == 1 ? '投放分组':'系统分组'}}
			</div> -->
			<!-- 组长 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.admin_name}}
			</div>
			<!-- 分组成员 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				<div style="display: flex;flex-wrap: wrap;">
					<div v-for="(item,index) in item.group_user" :key="index" style="margin-right: 10px;margin-bottom:3px;">
						{{item}}
					</div>
				</div>
				
			</div>
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange" />
		
	</div>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">小组名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_group_name" placeholder="请输入" style="width: 340px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">组长<span class="required-hint">*</span></div>
				
				<a-select
					show-search
					allowClear
				    style="width: 340px"
				    placeholder="请选择组长"
				    @change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:value="x_admin_id"
				  >
				    <a-select-option v-for="(value,key) in filterList" :key="key" :value="key">
				      {{value}}
				    </a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">小组成员<span class="required-hint">*</span></div>
				
				<!-- <div> -->
					<a-select
						mode="multiple"
						show-search
						allowClear
					    style="width: 340px"
					    placeholder="请选择小组成员"
					    @change="handleChangeB"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="x_group_user"
					  >
					    <a-select-option v-for="(value,key) in filterList" :key="key" :value="key">
					      {{value}}
					    </a-select-option>
					</a-select>
					
					<!-- <span style="margin-left: 15px;cursor: pointer;">删除</span> -->
				<!-- </div> -->
				
			</div>
			
			<!-- <div class="form-cell-box">
				<div class="class-title"></div>
					
				<a-button type="primary" icon="plus" size="small">新增小组成员</a-button>
			</div> -->
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putGroupList, putGroupAdd, putGroupEdit, logSelectUser } from '@/request/api'
export default {
	name: 'putGroup_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:110, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"小组名称", width:180, type:"group_name", },
				// {title:"分组类型", width:180, type:"group_type", },
				{title:"组长", width:180, type:"admin_name", },
				{title:"分组成员", width:260, type:"group_user", },
				{title:"操作", width:130, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			r_limit: 20,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			
			x_id: "", // id，用于编辑
			
			x_pid: undefined, // 父类ID
			
			filterList: {},
			x_group_name: "",
			x_admin_id: undefined, // 组长
			x_group_user: [], // 小组成员
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.table_scroll_width = table_info.table_width
		
		// 获取搜索条件
		logSelectUser().then(res=>{
			console.log('获取搜索条件',res.data.data)
			
			that.filterList = res.data.data.list
		})
		
		that.searchButton() 
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		addChangeA(e){
			console.log(e);
			this.x_pid = e
		},
		handleChangeA(e){ // 选择管理员
			this.x_admin_id = e
		},
		handleChangeB(e){ // 小组成员
			console.log(e);
			this.x_group_user = e
		},
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			putGroupList().then(res=>{
				console.log("投放分组-列表",res.data);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增按钮
		addButton(){
			this.drawer_title = "新增"
			this.visible = true
		},
		// 编辑
		editTable(index,e){
			// console.log(e);
			let that = this
			this.drawer_title = "编辑"
			
			this.x_id = e.id
			this.x_group_name = e.group_name
			this.x_admin_id = e.admin_id.toString()
			this.x_group_user = Object.keys(e.group_user)
			
			this.visible = true
		},
		// 新增/编辑
		addRequest(){
			let that = this
			if(!that.x_group_name){
				that.add_form_hint = "请填写小组名称"
			}
			else if(!that.x_admin_id){
				that.add_form_hint = "请选择组长"
			}
			else if(!that.x_group_user){
				that.add_form_hint = "请选择小组成员"
			}
			else {
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					putGroupAdd({
						group_name: that.x_group_name,
						admin_id: that.x_admin_id,
						group_user: that.x_group_user,
						group_type: 1, // 分组类型固定写死
					}).then(res=>{
						console.log("新增",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					putGroupEdit({
						id: that.x_id,
						group_name: that.x_group_name,
						admin_id: that.x_admin_id,
						group_user: that.x_group_user,
						group_type: 1, // 分组类型固定写死
					}).then(res=>{
						console.log("编辑",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.x_id = ""
			this.x_group_name = null
			this.x_admin_id = undefined // 组长
			this.x_group_user = [] // 小组成员
			
			this.add_form_hint = ""
			
			this.visible = false
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton()
		}
	},
	filters: {
		tableToText(value){
			// console.log("过滤器",value)
			let text 
			if(value == 0){
				text = "投放"
			}
			else if(value == 1){
				text = "运营"
			}
			return text
		}
	}
}	
</script>

<style scoped>

</style>